import { useQuery } from "@tanstack/react-query";
import { LogIn, MailPlus, UserPlus, Users } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { apiFetch } from "@/lib/api";
import type { DashboardStats } from "@/lib/types";

interface CardConfig {
  titulo: string;
  descricao: string;
  icone: React.ComponentType<{ className?: string }>;
  valor: (s: DashboardStats) => number;
}

const cards: CardConfig[] = [
  { titulo: "Convites pendentes", descricao: "Aguardando aceite", icone: MailPlus, valor: (s) => s.convitesPendentes },
  { titulo: "Solicitações", descricao: "Aguardando aprovação", icone: UserPlus, valor: (s) => s.solicitacoesPendentes },
  { titulo: "Usuários ativos", descricao: "Total no banco", icone: Users, valor: (s) => s.usuariosAtivos },
  { titulo: "Logins (24h)", descricao: "Últimas 24 horas", icone: LogIn, valor: (s) => s.loginsUltimas24h },
];

export function DashboardPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: () => apiFetch<DashboardStats>("/api/admin/dashboard/stats"),
    staleTime: 30_000,
  });

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="font-display text-2xl font-semibold">Dashboard</h1>
        <p className="text-sm text-muted-foreground">Visão geral da plataforma.</p>
      </header>
      <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => {
          const Icone = c.icone;
          return (
            <Card key={c.titulo}>
              <CardHeader className="flex flex-row items-start justify-between gap-2 pb-2">
                <div>
                  <CardDescription>{c.titulo}</CardDescription>
                  <CardTitle className="text-3xl">
                    {isLoading ? <Skeleton className="h-8 w-16" /> : isError ? "—" : data ? c.valor(data) : "—"}
                  </CardTitle>
                </div>
                <span className="flex size-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icone className="size-4" />
                </span>
              </CardHeader>
              <CardContent className="text-xs text-muted-foreground">{c.descricao}</CardContent>
            </Card>
          );
        })}
      </section>
    </div>
  );
}
